import { render, staticRenderFns } from "./class-student.pug?vue&type=template&id=7e47bbf0&lang=pug&"
import script from "./class-student.ts?vue&type=script&lang=ts&"
export * from "./class-student.ts?vue&type=script&lang=ts&"
import style0 from "./class-student.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports